import { useState } from 'react';

const FAQ_ITEMS = [
  {
    q: '韩国漫画和日本漫画有什么区别？',
    a: '韩国漫画（Webtoon）通常采用竖版全彩格式，适配手机屏幕阅读，画风更加明亮细腻；而日本漫画多为黑白横版。韩国漫画在叙事节奏上更适合移动端碎片化阅读，题材也更加多元化，涵盖奇幻、浪漫、悬疑、搞笑等多种类型。',
  },
  {
    q: '在哪里可以免费看韩国漫画？',
    a: 'NAVER Webtoon和Kakao Page是韩国最大的两个官方漫画平台，提供大量免费内容。此外，本站收录的韩国漫画网站大全中包含多个免费韩国漫画网站推荐，您可以根据人气排行和读者评价选择适合自己的阅读平台。',
  },
  {
    q: '如何找到最新更新的韩国漫画？',
    a: '本站「最新动态」模块每日更新各大韩国漫画网的更新信息，您也可以在「人气排行」中查看当前最热门的连载作品。此外，关注我们的「热门专题」可以获取精选的完结与新作推荐。',
  },
  {
    q: '韩国漫画网站需要注册才能看吗？',
    a: '大部分韩国漫画网站提供免费试读章节，部分平台需要注册账号才能解锁全部内容。本站推荐的免费韩国漫画网站大多无需注册即可浏览，方便读者快速体验。具体每个网站的政策可能不同，建议访问时查看网站说明。',
  },
  {
    q: '本站收录的韩国漫画网站安全可靠吗？',
    a: '我们严格筛选收录的韩国漫画网站，优先推荐官方正版平台和信誉良好的第三方网站。所有收录的韩国漫画网均经过编辑团队审核，确保读者获得安全、优质的阅读体验。如发现任何问题，欢迎通过「联系投稿」反馈。',
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-10">
          常见问题
        </h2>
        <div className="space-y-3">
          {FAQ_ITEMS.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-200/50 transition-colors"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <i
                  className={`ri-${openIndex === i ? 'subtract' : 'add'}-line text-lg text-foreground-500 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === i ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}